module.exports = __webpack_public_path__ + "img/shanchu.dafb777d.png";